module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("“Every day you have a choice – be part of the problem or part of the solution.”")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Francis fox was born in 1973 and was raised in ‘the dodgy end’ of South London.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Growing up he was highly motivated to improve his life experiences, and these early lessons forged his career as a management consultant and business turnaround expert.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("He has lived and worked around the world, stationed in Singapore, Thailand, Vietnam, Japan and Italy amongst others.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("A keen cyclist and with a strong penchant for Asian cuisine, he now shares his time with his family between Australia, Japan and the family home in Thailand along with five rescue cats (and counting).")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("An Italian speaker and a student of Japanese currently, he is always looking to learn about new cultures and customs and this vibe has passed down to his children.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Gas Meter Knees is his first book and it’s a rollercoaster ride through his formative years in 1980’s London that will make you laugh, cry and lots in between ‘sometimes you’re the pigeon – sometimes you’re the statue’.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0